import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FormControl from 'web-library/stories/atom/FormControl/FormControl';
import { Box, CustomSelect } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { KeyValueResponse } from '../../../api/model';
import { MenuItems } from '../../../components/select/model';
import { useGetOrganisationUuidList } from '../../../api-refactored/user/useGetOrganisationUuidList';
import LoadingComponent from '../../../components/LoadingComponent';

const useStyles = makeStyles()((theme) =>
({
  formControlRoot: {
    width: '100%',
  },
}));

export interface EligibleSchoolsOptionProps {
  /** to handle select on change event
   * */
  onChange?: (event: KeyValueResponse) => void;

  /** to define select control selected value
   * */
  value: any;

  /**
   * to defined the selector is disabled
   */
  disabled: boolean;
}

/** React Component
 *  Reusable Organization Select Option
 * ** */
const EligibleSchoolOptions: React.FC<EligibleSchoolsOptionProps> = (
  props: EligibleSchoolsOptionProps
) => {
  const { onChange = (event: KeyValueResponse) => null, value, disabled } = props;

  const { classes } = useStyles();

  const { data: schools, isLoading } = useGetOrganisationUuidList();
  const { t } = useTranslation();

  /**
   * map organization data to [MenuItems]
   * */
  const organizationDropDownData = useMemo<MenuItems[]>(() => {
    if (!schools) {
      return [];
    }
    return schools.map((option) => ({
      children: option.description,
      value: option.code,
      key: `k-${option.code}`,
    }));
  }, [schools]);

  /** handle organization selected option change
   * */
  const onSelectedOptionChange = (selectedValue: any) => {
    if (schools && schools.length > 0) {
      const selectedOption = schools.find((school) => school.code === selectedValue);
      if (selectedOption) {
        onChange(selectedOption);
      }
    }
  };

  return isLoading ? (
    <LoadingComponent isOpaque />
  ) : (
    <Box>
      <FormControl id="school-select-formcontrol" className={classes.formControlRoot}>
        <CustomSelect
          label={t('admin->>UniqueLink.School')}
          displayEmpty
          id="school-select"
          menuItems={organizationDropDownData}
          onChange={(e) => onSelectedOptionChange(e.target.value)}
          value={value}
          variant="filled"
          disabled={disabled}
        />
      </FormControl>
    </Box>
  );
};
export default EligibleSchoolOptions;
